import React, {useState, useEffect} from 'react';
import {useForm, FormProvider} from 'react-hook-form';
import {yupResolver} from '@hookform/resolvers';
import SelectInfinite from '../../../components/FormFields/SelectInfinite';
import InputText from '../../../components/FormFields/InputText';
import TextArea from '../../../components/FormFields/Textarea';
import * as yup from 'yup';
import {getLanguage, t} from 'react-switch-lang';
import {Col, Row} from 'react-bootstrap';
import PageHeader from '../components/PageHeader';
import {useHistory} from 'react-router-dom';
import {
  getAllSubProcesses,
  addPotentialRisk,
  getRiskEstimations,
  getAllSubCauses,
  getMethodology,
  getDepartment,getAllSubCategories
} from '../../../services/potentialRiskService';
import SelectList from '../../../components/select/SelectList';
import './AddPotentialRisk.scss';
import {useUserContext} from '../../../contexts/UserContext';
import Toast from '../../../components/toast/Toast';
import {useDepartmentContext} from '../../../contexts/DepartmentContext';
import allowedFileTypes from '../../../utils/allowedFileTypes';
import PreventTransitionPrompt from '../../../components/preventTransitionprompt/PreventTransition';
import FileUploadSection from "../../../components/FileUploadSection/FileUploadSection";
import {getAllRiskTypes} from "../../../services/reports/reports";
import {appModules, validDouble} from '../../../utils/const';
import {RISK_COLOR_MAP} from '../../../utils/helpers';
import externalization from '../../externalization/Externalization';

const AddPotentialRisk = () => {
  const lang = getLanguage();
  const user = useUserContext();
  const userDepartment = useDepartmentContext();

  const [disableSubprocess, setDisableSubPorcess] = useState(true);
  const [disableSubCauses, setDisableSubCauses] = useState(true);
  const [subCategories, setSubCategories] = useState([]);
  const [disableSubCategory, setDisableSubCategory] = useState(true);
  const [hasMoreSubCategories, setHasMoreSubCategories] = useState(true);
  const [loadingSubCategories, setLoadingSubCategories] = useState(false);
  const [subCategoryPage, setSubCategoryPage] = useState(0);
  const [subProcesses, setSubProcesses] = useState([]);
  const [subCauses, setSubCauses] = useState([]);
  const disableRiskEstimation = true;
  const [riskEstimation, setRiskEstimation] = useState('');
  const [riskEstimationId, setRiskEstimationId] = useState();
  const [riskEstimationColor, setRiskEstimationColor] = useState();
  const [userResponsibleLogin,setUserResponsibleLogin] = useState();
  const [isAdding, setIsAdding] = useState(true);
  const [methodology, setMethodology] = useState();
  const [subprocessPage, setSubprocessPage] = useState(0);
  const [hasMoreSubprocesses, setHasMoreSubprocesses] = useState(true);
  const [loadingSubprocesses, setLoadingSubprocesses] = useState(false);
  const [subCausePage, setSubCausePage] = useState(0);
  const [hasMoreSubCauses, setHasMoreSubCauses] = useState(true);
  const [loadingSubCauses, setLoadingSubCauses] = useState(false);
  const [disableRiskCause, setDisableRiskCause] = useState(true);
  const [subprocessSearch, setSubprocessSearch] = useState('');
  const [subCategoriesSearch, setSubcategoriesSearch] = useState('');
  const [subcausesSearch, setSubcausesSearch] = useState('');
  let history = useHistory();

  const [schema, setSchema] = useState(
    yup.object().shape({
      title: yup
        .string()
        .trim()
        .required(t('message.fieldRequired'))
        .max(150, t('message.max', {max: 150})),
      potentialRiskType: yup
        .object()
        .nullable()
        .required(t('message.fieldRequired')),
      description: yup
        .string()
        .trim()
        .required(t('message.fieldRequired'))
        .max(2048, t('message.max', {max: 2048})),
      riskCause: yup.object().nullable().required(t('message.fieldRequired')),
      riskSubCause: yup
        .object()
        .nullable()
        .required(t('message.fieldRequired')),
      riskCategory: yup
        .object()
        .nullable()
        .required(t('message.fieldRequired')),
      riskSubCategory: yup
        .object()
        .nullable()
        .required(t('message.fieldRequired')),
      process: yup.object().nullable().required(t('message.fieldRequired')),
      subprocess: yup.object().nullable().required(t('message.fieldRequired')),
      businessLine: yup
        .object()
        .nullable()
        .required(t('message.fieldRequired')),
      // methodology: yup.object().nullable().required(t('message.fieldRequired')),
      departmentStakeholder: yup
        .object()
        .nullable()
        .required(t('message.fieldRequired')),
      frequencyOccurrenceOr: yup
        .object()
        .nullable()
        .required(t('message.fieldRequired')),
      financialPerformance: yup
        .object()
        .nullable()
        .required(t('message.fieldRequired')),
      riskMitigationModeName: yup
        .object()
        .nullable()
        .required(t('message.fieldRequired')),
      comment: yup
        .string()
        .trim()
        .max(2048, t('message.max', {max: 2048})),
      departmentSourceId: yup
        .object()
        .nullable()
        .required(t('message.fieldRequired')),
    }),
  );

  const methods = useForm({
    resolver: yupResolver(schema),
  });

  const {handleSubmit, watch, setValue} = methods;
  const watchProcess = watch('process');
  const watchFrequencyOccurrenceOr = watch('frequencyOccurrenceOr');
  const watchFinancialPerformance = watch('financialPerformance');
  const watchRiskCause = watch('riskCause');
  const watchDepartmentSourceId = watch('departmentSourceId');
  const watchRiskCategory = watch('riskCategory');
  const watchRiskType = watch('potentialRiskType')
  const watchRiskSubCategory = watch('riskSubCategory');
  const watchSubprocess = watch('subprocess');
  const watchSubcause = watch('riskSubCause');

  const fetchSubprocesses = async (pageToLoad = 0, replace = false, search='') => {
    if (!watchProcess?.value) return;
    try {
      setLoadingSubprocesses(true);
      const {data} = await getAllSubProcesses(
        watchProcess?.value,
        pageToLoad,
        20,
        search
      );
      const mapped = data?.map((item) =>
        lang === 'eng'
          ? {value: item?.id, label: item?.nameEn}
          : {value: item?.id, label: item?.name}
      );
      setSubProcesses(prev =>
        replace ? mapped : [...prev, ...mapped]
      );

      setSubprocessPage(pageToLoad);
      setHasMoreSubprocesses(data.length === 20);
    }
    catch (e){
    }finally {
      setLoadingSubprocesses(false);
    }
  };

  const fetchSubcauses = async (pageToLoad = 0, replace = false, search='') => {
    if (!watchRiskCause?.value) return;
    try {
      setLoadingSubCauses(true);
      const {data} = await getAllSubCauses(
        watchRiskCause.value,
        watchRiskSubCategory?.value,
        pageToLoad,
        20,
        search
      );
      const mapped = data?.map((item) =>
        lang === 'eng'
          ? {value: item?.id, label: item?.nameEn}
          : {value: item?.id, label: item?.name}
      );
      setSubCauses(prev =>
        replace ? mapped : [...prev, ...mapped]
      );
      setSubCausePage(pageToLoad);
      setHasMoreSubCauses(data.length === 20);
    } catch (e) {
    }finally {
      setLoadingSubCauses(false);
    }
  };
  const fetchSubCategories = async (pageToLoad = 0, replace = false, search='') => {
    if (!watchRiskCategory?.value) return;
    try {
      setLoadingSubCategories(true);
      const {data} = await getAllSubCategories(
        watchRiskCategory.value,
        pageToLoad,
        20,
        search
      );
      const mapped = data?.map((item) =>
        lang === 'eng'
          ? {value: item?.id, label: item?.nameEn}
          : {value: item?.id, label: item?.name}
      );
      setSubCategories(prev =>
        replace ? mapped : [...prev, ...mapped]
      );
      setSubCategoryPage(pageToLoad);
      setHasMoreSubCategories(data.length === 20);
    } catch (e) {
    }finally {
      setLoadingSubCategories(false);
    }
  };

  const fetchMethodology = async () => {
    try {
      const {data} = await getMethodology();
      data.map((i) => {
        if (i === 2) {
          setMethodology({
            value: i.id,
            label: lang === 'mne' ? i.name : i.nameEn,
          });
        }
      });
      return data;
    } catch (e) {}
  };

  const fetchRiskEstimation = async () => {
    try {
      const {data} = await getRiskEstimations(
        watchFrequencyOccurrenceOr['value'],
        watchFinancialPerformance['value']
      );
      return data;
    } catch (e) {}
  };

  const handleCancel = (e) => {
    e.preventDefault();
    window.location = '/dashboard';
  };

  const submitForm = async (data) => {
    const files = document.getElementById('upload').files;
    const riskTypes = await getAllRiskTypes();
    const isDelayedVerification = riskTypes?.data.find((riskType) => riskType.id === 1).delayedVerification;
    const payload = {
      applicationDate: new Date(),
      title: data.title,
      potentialRiskTypeId: data.potentialRiskType.value,
      description: data.description,
      riskCauseId: data.riskCause.value,
      riskSubCauseId: data.riskSubCause.value,
      riskCategoryId: data.riskCategory.value,
      subcategoryId: data?.riskSubCategory?.value,
      riskTypeId: 1,
      userCreatedId: user.id,
      userInChargeId: user.id,
      userInChargeLogin: user.login,
      userResponsibleId: data.userResponsible.value,
      userResponsibleLogin: userResponsibleLogin,
      processId: data.process.value,
      subprocessId: data.subprocess.value,
      businessLineId: data.businessLine.value,
      // methodologyId: data.methodology.value,
      departmentStakeholderId: data.departmentStakeholder.value,
      departmentSourceId: data.departmentSourceId.value,
      riskEstimationId: riskEstimationId,
      riskMitigationModeId: data?.riskMitigationModeName?.value,
      riskMitigationModeName: data?.riskMitigationModeName?.label,
      comment: data.comment,
      delayedVerification: isDelayedVerification,
      externalizationId: data?.externalizationId?.value
    };

    try {
      const response = await addPotentialRisk(payload, files);
      if (response.status === 201) {
        await Toast.fire({
          title: t('potentialRisk.messages.addSuccess'),
          icon: 'success',
        });
        setIsAdding(false);
      }
      await history.push(`/potential-risk/${response.data.id}`);
    } catch (err) {
      if (err.response.data.code === 'risk-exists') {
        Toast.fire({
          title:
            lang === 'eng'
              ? err.response.data.description
              : t('potentialRisk.messages.addErrorExists'),
          icon: 'error',
        });
        document.getElementById('title').focus();
        document.getElementById('title').select();
      } else {
        Toast.fire({
          title: t('potentialRisk.messages.addError'),
          icon: 'error',
        });
        setIsAdding(false);
      }
    }
  };
  useEffect(() => {
    if (!watchProcess?.value) return;

    if (!watchSubprocess) {
      setSubprocessSearch('');
      setSubprocessPage(0);
      setHasMoreSubprocesses(true);
      fetchSubprocesses(0, true, '');
    }
  }, [watchSubprocess]);
  useEffect(() => {
    if (!watchRiskCategory?.value) return;

    if (!watchRiskSubCategory) {
      setSubcategoriesSearch('');
      setSubCategoryPage(0);
      setHasMoreSubCategories(true);
      fetchSubCategories(0, true, '');
    }
  }, [watchRiskSubCategory]);
  useEffect(() => {
    if (!watchRiskCause?.value) return;

    if (!watchSubcause) {
      setSubcausesSearch('');
      setSubCausePage(0);
      setHasMoreSubCauses(true);
      fetchSubcauses(0, true, '');
    }
  }, [watchSubcause]);
  useEffect(() => {
    if (watchProcess?.value) {
      setDisableSubPorcess(false);
      setSubProcesses([]);
      setSubprocessPage(0);
      setHasMoreSubprocesses(true);
      setValue('subprocess', '', {
        shouldValidate: false,
        shouldDirty: false,
      });
      setSubprocessSearch('');
      fetchSubprocesses(0, true, '');
    } else {
      setDisableSubPorcess(true);
      setSubProcesses([]);
      setSubprocessPage(0);
      setHasMoreSubprocesses(true);
      setValue('subprocess', '', {
        shouldValidate: false,
        shouldDirty: false,
      });
    }
  }, [watchProcess]);
  useEffect(() => {
    if (watchRiskCause?.value) {
      setDisableSubCauses(false);
      setSubCauses([]);
      setSubCausePage(0);
      setHasMoreSubCauses(true);
      setValue('riskSubCause', '', {
        shouldValidate: false,
        shouldDirty: false,
      });
      setSubcausesSearch('')
      fetchSubcauses(0, true, '');
    } else {
      setDisableSubCauses(true);
      setSubCauses([]);
      setSubCausePage(0);
      setHasMoreSubCauses(true);
      setValue('riskSubCause', '', {
        shouldValidate: false,
        shouldDirty: false,
      });
    }
  }, [watchRiskCause]);
  useEffect(() => {
    if (watchRiskCategory?.value) {
      setDisableSubCategory(false);
      setSubCategories([]);
      setSubCategoryPage(0);
      setHasMoreSubCategories(true);
      setValue('riskSubCategory', '', {
        shouldValidate: false,
        shouldDirty: false,
      });
      setValue('riskCause', null, {
        shouldValidate: false,
        shouldDirty: false,
      });

      setValue('riskSubCause', null, {
        shouldValidate: false,
        shouldDirty: false,
      });
      setDisableRiskCause(true);
      setDisableSubCauses(true);
      setSubCauses([]);
      setSubCausePage(0);
      setHasMoreSubCauses(true);
      setSubcategoriesSearch('')
      fetchSubCategories(0, true, '');
    } else {
      setDisableSubCategory(true);
      setDisableRiskCause(true);
      setDisableSubCauses(true);

      setSubCategories([]);
      setSubCauses([]);

      setSubCategoryPage(0);
      setSubCausePage(0);

      setHasMoreSubCategories(true);
      setHasMoreSubCauses(true);

      setValue('riskSubCategory', null, {
        shouldValidate: false,
        shouldDirty: false,
      });

      setValue('riskCause', null, {
        shouldValidate: false,
        shouldDirty: false,
      });

      setValue('riskSubCause', null, {
        shouldValidate: false,
        shouldDirty: false,
      });
    }
  }, [watchRiskCategory]);
  const getRiskColor = (risk) => {
    setRiskEstimationColor(RISK_COLOR_MAP[risk?.color] || '#000');
  };
  useEffect(() => {
    if (watchRiskCategory?.value && watchRiskSubCategory?.value) {
      setDisableRiskCause(false);
    } else {
      setDisableRiskCause(true);

      setValue('riskCause', null, {
        shouldValidate: false,
        shouldDirty: false,
      });

      setValue('riskSubCause', null, {
        shouldValidate: false,
        shouldDirty: false,
      });

      setDisableSubCauses(true);
      setSubCauses([]);
      setSubCausePage(0);
      setHasMoreSubCauses(true);
    }
  }, [watchRiskCategory, watchRiskSubCategory]);

  useEffect(() => {
    if (watchFrequencyOccurrenceOr?.value && watchFinancialPerformance?.value) {
      fetchRiskEstimation().then((r) => {
        const risk = r[0];
        if (risk.evaluation !== riskEstimation) {
          setRiskEstimation(
            lang === 'eng' ? risk.evaluationEn : risk.evaluation
          );
          getRiskColor(risk);
          setRiskEstimationId(risk.id);
        } else {
          // Needs to be set 2 times since key rerender reacts only on change
          setRiskEstimation('');
          setRiskEstimation(riskEstimation);
          setRiskEstimationColor('');
          getRiskColor(risk);
          setRiskEstimationId(risk.id);
        }
      });
    }
    setValue('riskEstimation', '');
    if (
      watchFrequencyOccurrenceOr === null ||
      watchFinancialPerformance === null
    ) {
      setValue('riskEstimation', '', {
        shouldValidate: false,
        shouldDirty: false,
      });
    }
  }, [watchFrequencyOccurrenceOr, watchFinancialPerformance]);

  useEffect(() => {
    fetchMethodology();
  }, []);

  useEffect(() => {
    if (watchDepartmentSourceId) {
      const depratmentObject = async () => {
        try {
          const {data} = await getDepartment(watchDepartmentSourceId.value);
          setUserResponsibleLogin(data[0]?.userResponsibleLogin)
          setValue('userResponsible', {
            value: data[0].userResponsibleId,
            label:
              data[0].userResponsibleFirstName +
              ' ' +
              data[0].userResponsibleLastName,
          });
        } catch {}
      };
      depratmentObject();
    }
  }, [watchDepartmentSourceId]);

  const handleSubprocessLoadMore = () => {
    if (hasMoreSubprocesses && !loadingSubprocesses) {
      fetchSubprocesses(subprocessPage + 1, false, subprocessSearch);
    }
  };
  const handleRiskSubCauseLoadMore = () => {
    if (hasMoreSubCauses && !loadingSubCauses) {
      fetchSubcauses(subCausePage + 1, false, subcausesSearch);
    }
  };
  const handleRiskSubCategoryLoadMore = () => {
    if (hasMoreSubCategories && !loadingSubCategories) {
      fetchSubCategories(subCategoryPage + 1, false, subCategoriesSearch);
    }
  };
  const handleSubprocessSearch = (value) => {
    setSubprocessSearch(value);
    setSubprocessPage(0);
    setHasMoreSubprocesses(true);
    if (!value) {
      fetchSubprocesses(0, true, '');
      return;
    }
    fetchSubprocesses(0, true, value);
  };
  const handleSubcategoriesSearch = (value) => {
    setSubcategoriesSearch(value);
    setSubCategoryPage(0);
    setHasMoreSubCategories(true);
    if (!value) {
      fetchSubCategories(0, true, '');
      return;
    }
    fetchSubCategories(0, true, value);
  };
  const handleSubcausesSearch = (value) => {
    setSubcausesSearch(value);
    setSubCausePage(0);
    setHasMoreSubCauses(true);
    if (!value) {
      fetchSubcauses(0, true, '');
      return;
    }
    fetchSubcauses(0, true, value);
  };
  return (
    <>
      <PreventTransitionPrompt when={isAdding} />
      <PageHeader />
      <div className="main-form mt-4">
        <FormProvider {...methods}>
          <form onSubmit={handleSubmit(submitForm)}>
            <Row className="field-group-title">
              <Col className="col-4 col-xl-2">
                {t('potentialRisk.mainData')}
              </Col>
            </Row>
            <Row className="mb-2">
              <Col className="col-6 col-xl-3">
                <label className="label-potential-risk">
                  {t('potentialRisk.title')}
                </label>
                <InputText
                  type="text"
                  name="title"
                  id="title"
                  className="form-control input-field"
                  placeholder={t('potentialRisk.placeholder.title')}
                />
                <label className="label-potential-risk">
                  {t('potentialRisk.potentialRiskType')}
                </label>
                <SelectInfinite
                  api="potential-risk-types"
                  name="potentialRiskType"
                  placeholder={t('potentialRisk.placeholder.potentialRiskType')}
                  labelKey={lang === 'mne' ? 'name' : 'nameEn'}
                  className="select"
                />
                {watchRiskType?.value === 2 && <>
                <label className="label-potential-risk">
                  {t('externalization.externalization')}
                </label>
                  <span className="optional register">
                  {t('common.optional')}
                </span>
                <SelectInfinite
                  api="externalizations"
                  name="externalizationId"
                  placeholder={t('externalization.placeholder.externalization')}
                  labelKey={'contractSubject'}
                  className="select"
                  queryKeys={'search.contains'}
                />
                </>}
              </Col>
              <Col className="col-6 col-xl-3">
                <label className="label-potential-risk">
                  {t('potentialRisk.description')}
                </label>
                <TextArea
                  name="description"
                  className={`form-control text-area `}
                  placeholder={t('potentialRisk.placeholder.description')}
                />
              </Col>
            </Row>
            <Row className="mt-5 field-group-title">
              <Col className="col-6 col-xl-3">
                {t('potentialRisk.additionalInformation')}
              </Col>
            </Row>
            <Row className="mt-2">
              <Col className="col-3 col-xl-3">
                <label className="label-potential-risk">
                  {t('potentialRisk.riskCategory')}
                </label>
                <SelectInfinite
                  api="risk-categories?active.equals=true"
                  name="riskCategory"
                  placeholder={t('potentialRisk.placeholder.riskCategory')}
                  labelKey={lang === 'mne' ? 'name' : 'nameEn'}
                  className="select"
                />
                <label className="label-potential-risk">
                  {t('potentialRisk.riskSubCategory')}
                </label>
                <SelectList
                  name="riskSubCategory"
                  isDisabled={disableSubCategory}
                  className="select"
                  placeholder={t('potentialRisk.placeholder.riskSubCategory')}
                  options={subCategories}
                  isClearable
                  onLoadMore={handleRiskSubCategoryLoadMore}
                  hasMore={hasMoreSubCategories}
                  isLoading={loadingSubCategories}
                  onSearch={handleSubcategoriesSearch}
                />
                <label className="label-potential-risk">
                  {t('potentialRisk.riskCause')}
                </label>
                <SelectInfinite
                  key={`riskCause-${watchRiskSubCategory?.value || 'empty'}`}
                  api={
                    watchRiskSubCategory?.value
                      ? `risk-causes?riskSubCategoryId.equals=${watchRiskSubCategory.value}`
                      : 'risk-causes'
                  }
                  name="riskCause"
                  placeholder={t('potentialRisk.placeholder.riskCause')}
                  labelKey={lang === 'mne' ? 'name' : 'nameEn'}
                  className="select"
                  isDisabled={!watchRiskSubCategory?.value || disableRiskCause}
                />
                <label className="label-potential-risk">
                  {t('potentialRisk.riskSubCause')}
                </label>
                <SelectList
                  name="riskSubCause"
                  isDisabled={disableSubCauses}
                  className="select"
                  placeholder={t('potentialRisk.placeholder.riskSubCause')}
                  options={subCauses}
                  isClearable
                  onLoadMore={handleRiskSubCauseLoadMore}
                  hasMore={hasMoreSubCauses}
                  isLoading={loadingSubCauses}
                  onSearch={handleSubcausesSearch}
                />
              </Col>
              <Col className="col-3 col-xl-3">
                <label className="label-potential-risk">
                  {t('potentialRisk.process')}
                </label>
                <SelectInfinite
                  api="processes?active.equals=true"
                  name="process"
                  placeholder={t('potentialRisk.placeholder.process')}
                  labelKey={lang === 'mne' ? 'name' : 'nameEn'}
                  className="select"
                />
                <label className="label-potential-risk">
                  {t('potentialRisk.subprocess')}
                </label>
                <SelectList
                  name="subprocess"
                  isDisabled={disableSubprocess}
                  placeholder={t('potentialRisk.placeholder.subprocess')}
                  options={subProcesses}
                  isClearable
                  onLoadMore={handleSubprocessLoadMore}
                  hasMore={hasMoreSubprocesses}
                  isLoading={loadingSubprocesses}
                  onSearch={handleSubprocessSearch}
                />
                <label className="label-potential-risk">
                  {t('potentialRisk.businessLine')}
                </label>
                <SelectInfinite
                  api="business-lines"
                  name="businessLine"
                  placeholder={t('potentialRisk.placeholder.businessLine')}
                  labelKey={lang === 'mne' ? 'name' : 'nameEn'}
                  className="select"
                />
                <label className="label-potential-risk" htmlFor={'attachFile'}>
                  {t('potentialRisk.attachFiles')}
                </label>
                <FileUploadSection
                  disabled={false}
                  allowedFileTypes={allowedFileTypes}
                />
                {/*<label className="label-potential-risk">*/}
                {/*  {t('potentialRisk.methodology')}*/}
                {/*</label>*/}
                {/*<SelectInfinite*/}
                {/*  api="methodologies"*/}
                {/*  name="methodology"*/}
                {/*  placeholder={t('potentialRisk.placeholder.methodology')}*/}
                {/*  labelKey={lang === 'mne' ? 'name' : 'nameEn'}*/}
                {/*  className="select"*/}
                {/*  defaultValue={methodology}*/}
                {/*/>*/}
              </Col>
              <Col className="col-3 col-xl-3">
                <label className="label-potential-risk">
                  {t('potentialRisk.financialPerformance')}
                </label>
                <SelectInfinite
                  api="financial-performances?sort=id,desc"
                  name="financialPerformance"
                  placeholder={t(
                    'potentialRisk.placeholder.financialPerformance'
                  )}
                  labelKey={lang === 'mne' ? 'name' : 'nameEn'}
                  className="select"
                />
                <label className="label-potential-risk">
                  {t('potentialRisk.frequencyOccurrenceOr')}
                </label>
                <SelectInfinite
                  api="frequency-occurence-risks"
                  name="frequencyOccurrenceOr"
                  placeholder={t(
                    'potentialRisk.placeholder.frequencyOccurrenceOr'
                  )}
                  labelKey={lang === 'mne' ? 'name' : 'nameEn'}
                  className="select"
                />
                <label className="label-potential-risk">
                  {t('potentialRisk.riskEstimation')}
                </label>
                {/*Can't use InputText component since it has ref register and color needs to change*/}
                {/*passing !important trough another ref since react doesn't accept it in inline style as variable (#ffffff !important)*/}
                <input
                  key={riskEstimation}
                  className="form-control input-field"
                  value={riskEstimation.toUpperCase()}
                  type="text"
                  disabled={disableRiskEstimation}
                  ref={(el) => {
                    if (el) {
                      el.style.setProperty(
                        'color',
                        riskEstimationColor,
                        'important'
                      );
                    }
                  }}
                />
                <label className="label-potential-risk">
                  {t('mitigation-measures.method')}
                </label>
                <SelectInfinite
                  api="/risk-mitigation-modes"
                  name="riskMitigationModeName"
                  labelKey={lang === 'mne' ? 'name' : 'nameEn'}
                  className="select"
                  placeholder={t('placeholder.riskMitigrationMethod')}
                />
              </Col>
              <Col className="col-3 col-xl-3">
                <label className="label-potential-risk">
                  {t('potentialRisk.departmentRisk')}
                </label>
                {(userDepartment?.length === 1 && userDepartment[0]?.active) ? (
                  <SelectInfinite
                    api={`departments/departments-user-in-charge?appModuleId.equals=${appModules?.riskModule}&active.equals=true`}
                    name="departmentSourceId"
                    placeholder={t('potentialRisk.placeholder.departmentRisk')}
                    labelKey={lang === 'mne' ? 'name' : 'nameEn'}
                    className="select"
                    defaultValue={{
                      value:
                        userDepartment[0]?.id !== undefined
                          ? userDepartment[0]?.id
                          : '',
                      label:
                        userDepartment[0]?.id !== undefined
                          ? lang === 'mne'
                            ? userDepartment[0]?.name
                            : userDepartment[0]?.nameEn
                          : '',
                    }}
                    isDisabled={true}
                  />
                ) : (
                  <SelectInfinite
                    api={`departments/departments-user-in-charge?appModuleId.equals=${appModules?.riskModule}&active.equals=true`}
                    name="departmentSourceId"
                    placeholder={t('potentialRisk.placeholder.departmentRisk')}
                    labelKey={lang === 'mne' ? 'name' : 'nameEn'}
                    className="select"
                  />
                )}
                <label className="label-potential-risk">
                  {t('potentialRisk.departmentStakeholder')}
                </label>
                <SelectInfinite
                  api={`departments?appModuleId.equals=${appModules?.riskModule}&active.equals=true`}
                  name="departmentStakeholder"
                  placeholder={t(
                    'potentialRisk.placeholder.departmentStakeholder'
                  )}
                  labelKey={lang === 'mne' ? 'name' : 'nameEn'}
                  className="select"
                />
                {(userDepartment?.length === 1 && userDepartment[0]?.active) ? (
                  <>
                    <label className="label-potential-risk">
                      {t('potentialRisk.userResponsible')}
                    </label>
                    <SelectInfinite
                      api="users"
                      name="userResponsible"
                      labelKey="firstName"
                      placeholder={t(
                        'potentialRisk.placeholder.userResponsible'
                      )}
                      className="select"
                      isDisabled={true}
                      defaultValue={{
                        value:
                          userDepartment[0]?.id !== undefined
                            ? userDepartment[0]?.userResponsibleId
                            : '',
                        label:
                          userDepartment[0]?.id !== undefined
                            ? userDepartment[0]?.userResponsibleFirstName +
                            ' ' +
                            userDepartment[0]?.userResponsibleLastName
                            : '',
                      }}
                    />
                  </>
                ) : (
                  <>
                    <label className="label-potential-risk">
                      {t('potentialRisk.userResponsible')}
                    </label>
                    <SelectInfinite
                      api="users"
                      name="userResponsible"
                      labelKey="firstName"
                      placeholder={t(
                        'potentialRisk.placeholder.userResponsible'
                      )}
                      className="select"
                      isDisabled={true}
                    />
                  </>
                )}
                <label className="label-potential-risk">
                  {t('potentialRisk.comment')}
                </label>
                <span className="optional register">
                  {t('common.optional')}
                </span>
                <TextArea
                  name="comment"
                  className={`form-control text-area`}
                  placeholder={t('potentialRisk.placeholder.comment')}
                />
              </Col>
            </Row>
            <Row className="mt-5 form-footer">
              <button
                className="secondary-btn"
                type="reset"
                onClick={handleCancel}
              >
                {t('buttons.cancel')}
              </button>
              <button className="primary-btn">{t('buttons.save')}</button>
            </Row>
          </form>
        </FormProvider>
      </div>
    </>
  );
};
export default AddPotentialRisk;
